import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { x } from '@xstyled/styled-components';
import { useTranslation } from 'react-i18next';
import { CheckIcon } from '../icons/check-icon';
export function RatingSuccess() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(x.section, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    w: "100%",
    children: [/*#__PURE__*/_jsx(x.span, {
      "aria-label": t('ARIA_LABEL_CHECK_ICON'),
      children: /*#__PURE__*/_jsx(CheckIcon, {})
    }), /*#__PURE__*/_jsx(x.span, {
      fontSize: "15px",
      px: "16px",
      lineHeight: "18px",
      color: "gray-700",
      w: "100%",
      children: t('THANKS_FOR_FEEDBACK')
    })]
  });
}